import styled from "styled-components/macro";

export default styled.div`
  color: #d8000c;
  font-size: 1.4rem;
  margin-top: 0.5rem;
`;
